"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "CheckMarkLegacy": "\uE001",
    "CheckboxFillLegacy": "\uE002",
    "CheckboxLegacy": "\uE003",
    "CheckboxIndeterminateLegacy": "\uE004",
    "CheckboxCompositeReversedLegacy": "\uE005",
    "HeartLegacy": "\uE006",
    "HeartBrokenLegacy": "\uE007",
    "CheckMarkZeroWidthLegacy": "\uE008",
    "CheckboxFillZeroWidthLegacy": "\uE009",
    "RatingStarFillZeroWidthLegacy": "\uE00A",
    "HeartFillZeroWidthLegacy": "\uE00B",
    "HeartBrokenZeroWidthLegacy": "\uE00C",
    "ScrollChevronLeftLegacy": "\uE00E",
    "ScrollChevronRightLegacy": "\uE00F",
    "ScrollChevronUpLegacy": "\uE010",
    "ScrollChevronDownLegacy": "\uE011",
    "ChevronLeft3Legacy": "\uE012",
    "ChevronRight3Legacy": "\uE013",
    "ChevronUp3Legacy": "\uE014",
    "ChevronDown3Legacy": "\uE015",
    "ScrollChevronLeftBoldLegacy": "\uE016",
    "ScrollChevronRightBoldLegacy": "\uE017",
    "ScrollChevronUpBoldLegacy": "\uE018",
    "ScrollChevronDownBoldLegacy": "\uE019",
    "RevealPasswordLegacy": "\uE052",
    "EaseOfAccessLegacy": "\uE07F",
    "CheckmarkListviewLegacy": "\uE081",
    "RatingStarFillReducedPaddingHTMLLegacy": "\uE082",
    "KeyboardStandardLegacy": "\uE087",
    "KeyboardSplitLegacy": "\uE08F",
    "SearchboxLegacy": "\uE094",
    "ChevronLeft1Legacy": "\uE096",
    "ChevronRight1Legacy": "\uE097",
    "ChevronUp1Legacy": "\uE098",
    "ChevronDown1Legacy": "\uE099",
    "ChevronLeft2Legacy": "\uE09A",
    "ChevronRight2Legacy": "\uE09B",
    "ChevronUp2Legacy": "\uE09C",
    "ChevronDown2Legacy": "\uE09D",
    "ChevronLeft4Legacy": "\uE09E",
    "ChevronRight4Legacy": "\uE09F",
    "ChevronUp4Legacy": "\uE0A0",
    "ChevronDown4Legacy": "\uE0A1",
    "CheckboxCompositeLegacy": "\uE0A2",
    "HeartFillLegacy": "\uE0A5",
    "BackBttnArrow42Legacy": "\uE0A6",
    "BackBttnMirroredArrow42Legacy": "\uE0AB",
    "BackBttnMirroredArrow20Legacy": "\uE0AD",
    "ArrowHTMLLegacyMirrored": "\uE0AE",
    "RatingStarFillLegacy": "\uE0B4",
    "RatingStarFillSmallLegacy": "\uE0B5",
    "SemanticZoomLegacy": "\uE0B8",
    "BackBttnArrow20Legacy": "\uE0C4",
    "ArrowHTMLLegacy": "\uE0D5",
    "ChevronFlipLeftLegacy": "\uE0E2",
    "ChevronFlipRightLegacy": "\uE0E3",
    "ChevronFlipUpLegacy": "\uE0E4",
    "ChevronFlipDownLegacy": "\uE0E5",
    "CheckmarkMenuLegacy": "\uE0E7",
    "PreviousLegacy": "\uE100",
    "NextLegacy": "\uE101",
    "PlayLegacy": "\uE102",
    "PauseLegacy": "\uE103",
    "EditLegacy": "\uE104",
    "SaveLegacy": "\uE105",
    "ClearLegacy": "\uE106",
    "DeleteLegacy": "\uE107",
    "RemoveLegacy": "\uE108",
    "AddLegacy": "\uE109",
    "CancelLegacy": "\uE10A",
    "AcceptLegacy": "\uE10B",
    "MoreLegacy": "\uE10C",
    "RedoLegacy": "\uE10D",
    "UndoLegacy": "\uE10E",
    "HomeLegacy": "\uE10F",
    "UpLegacy": "\uE110",
    "ForwardLegacy": "\uE111",
    "BackLegacy": "\uE112",
    "FavoriteLegacy": "\uE113",
    "CameraLegacy": "\uE114",
    "SettingsLegacy": "\uE115",
    "VideoLegacy": "\uE116",
    "SyncLegacy": "\uE117",
    "DownloadLegacy": "\uE118",
    "MailLegacy": "\uE119",
    "FindLegacy": "\uE11A",
    "HelpLegacy": "\uE11B",
    "UploadLegacy": "\uE11C",
    "EmojiLegacy": "\uE11D",
    "TwoPageLegacy": "\uE11E",
    "LeaveChatLegacy": "\uE11F",
    "MailForwardLegacy": "\uE120",
    "ClockLegacy": "\uE121",
    "SendLegacy": "\uE122",
    "CropLegacy": "\uE123",
    "RotateCameraLegacy": "\uE124",
    "PeopleLegacy": "\uE125",
    "ClosePaneLegacy": "\uE126",
    "OpenPaneLegacy": "\uE127",
    "WorldLegacy": "\uE128",
    "FlagLegacy": "\uE129",
    "PreviewLinkLegacy": "\uE12A",
    "GlobeLegacy": "\uE12B",
    "TrimLegacy": "\uE12C",
    "AttachCameraLegacy": "\uE12D",
    "ZoomInLegacy": "\uE12E",
    "BookmarksLegacy": "\uE12F",
    "DocumentLegacy": "\uE130",
    "ProtectedDocumentLegacy": "\uE131",
    "PageFillLegacy": "\uE132",
    "MultiSelectLegacy": "\uE133",
    "CommentLegacy": "\uE134",
    "MailFillLegacy": "\uE135",
    "ContactInfoLegacy": "\uE136",
    "HangUpLegacy": "\uE137",
    "ViewAllLegacy": "\uE138",
    "MapPinLegacy": "\uE139",
    "PhoneLegacy": "\uE13A",
    "VideoChatLegacy": "\uE13B",
    "SwitchLegacy": "\uE13C",
    "ContactLegacy": "\uE13D",
    "RenameLegacy": "\uE13E",
    "ExpandTileLegacy": "\uE13F",
    "ReduceTileLegacy": "\uE140",
    "PinLegacy": "\uE141",
    "MusicInfoLegacy": "\uE142",
    "GoLegacy": "\uE143",
    "KeyBoardLegacy": "\uE144",
    "DockLeftLegacy": "\uE145",
    "DockRightLegacy": "\uE146",
    "DockBottomLegacy": "\uE147",
    "RemoteLegacy": "\uE148",
    "RefreshLegacy": "\uE149",
    "RotateLegacy": "\uE14A",
    "ShuffleLegacy": "\uE14B",
    "ListLegacy": "\uE14C",
    "ShopLegacy": "\uE14D",
    "SelectAllLegacy": "\uE14E",
    "OrientationLegacy": "\uE14F",
    "ImportLegacy": "\uE150",
    "ImportAllLegacy": "\uE151",
    "ShowAllFiles3Legacy": "\uE152",
    "ShowAllFiles1Legacy": "\uE153",
    "ShowAllFilesLegacy": "\uE154",
    "BrowsePhotosLegacy": "\uE155",
    "WebcamLegacy": "\uE156",
    "PictureLegacy": "\uE158",
    "SaveLocalLegacy": "\uE159",
    "CaptionLegacy": "\uE15A",
    "StopLegacy": "\uE15B",
    "ShowResultsLegacy": "\uE15C",
    "VolumeLegacy": "\uE15D",
    "RepairLegacy": "\uE15E",
    "MessageLegacy": "\uE15F",
    "PageLegacy": "\uE160",
    "CalendarDayLegacy": "\uE161",
    "CalendarWeekLegacy": "\uE162",
    "CalendarLegacy": "\uE163",
    "CharactersLegacy": "\uE164",
    "MailReplyAllLegacy": "\uE165",
    "ReadLegacy": "\uE166",
    "LinkLegacy": "\uE167",
    "AccountsLegacy": "\uE168",
    "ShowBccLegacy": "\uE169",
    "HideBccLegacy": "\uE16A",
    "CutLegacy": "\uE16B",
    "AttachLegacy": "\uE16C",
    "PasteLegacy": "\uE16D",
    "FilterLegacy": "\uE16E",
    "CopyLegacy": "\uE16F",
    "Emoji2Legacy": "\uE170",
    "ImportantLegacy": "\uE171",
    "MailReplyLegacy": "\uE172",
    "SlideshowLegacy": "\uE173",
    "SortLegacy": "\uE174",
    "ListLegacyMirrored": "\uE175",
    "ExpandTileLegacyMirrored": "\uE176",
    "ReduceTileLegacyMirrored": "\uE177",
    "ManageLegacy": "\uE178",
    "AllAppsLegacy": "\uE179",
    "DisconnectDriveLegacy": "\uE17A",
    "MapDriveLegacy": "\uE17B",
    "NewWindowLegacy": "\uE17C",
    "OpenWithLegacy": "\uE17D",
    "ContactPresenceLegacy": "\uE181",
    "PriorityLegacy": "\uE182",
    "UploadSkyDriveLegacy": "\uE183",
    "GotoTodayLegacy": "\uE184",
    "FontLegacy": "\uE185",
    "FontColorLegacy": "\uE186",
    "Contact2Legacy": "\uE187",
    "FolderLegacy": "\uE188",
    "AudioLegacy": "\uE189",
    "PlaceFolderLegacy": "\uE18A",
    "ViewLegacy": "\uE18B",
    "SetlockScreenLegacy": "\uE18C",
    "SetTileLegacy": "\uE18D",
    "CCJapanLegacy": "\uE18E",
    "CCEuroLegacy": "\uE18F",
    "CCLegacy": "\uE190",
    "StopSlideshowLegacy": "\uE191",
    "PermissionsLegacy": "\uE192",
    "HighlightLegacy": "\uE193",
    "DisableUpdatesLegacy": "\uE194",
    "UnfavoriteLegacy": "\uE195",
    "UnpinLegacy": "\uE196",
    "OpenLocalLegacy": "\uE197",
    "MuteLegacy": "\uE198",
    "ItalicLegacy": "\uE199",
    "UnderlineLegacy": "\uE19A",
    "BoldLegacy": "\uE19B",
    "MoveToFolderLegacy": "\uE19C",
    "LikeDislikeLegacy": "\uE19D",
    "DislikeLegacy": "\uE19E",
    "LikeLegacy": "\uE19F",
    "AlignRightLegacy": "\uE1A0",
    "AlignCenterLegacy": "\uE1A1",
    "AlignLeftLegacy": "\uE1A2",
    "ZoomLegacy": "\uE1A3",
    "ZoomOutLegacy": "\uE1A4",
    "OpenFileLegacy": "\uE1A5",
    "OtherUserLegacy": "\uE1A6",
    "AdminLegacy": "\uE1A7",
    "MailForwardLegacyMirrored": "\uE1A8",
    "GoLegacyMirrored": "\uE1AA",
    "DockLeftLegacyMirrored": "\uE1AB",
    "DockRightLegacyMirrored": "\uE1AC",
    "ImportLegacyMirrored": "\uE1AD",
    "ImportAllLegacyMirrored": "\uE1AE",
    "MailReplyLegacyMirrored": "\uE1AF",
    "ItalicCLegacy": "\uE1B0",
    "BoldGLegacy": "\uE1B1",
    "UnderlineSLegacy": "\uE1B2",
    "BoldFLegacy": "\uE1B3",
    "ItalicKLegacy": "\uE1B4",
    "UnderlineULegacy": "\uE1B5",
    "ItalicILegacy": "\uE1B6",
    "BoldNLegacy": "\uE1B7",
    "UnderlineRussianLegacy": "\uE1B8",
    "BoldRussionLegacy": "\uE1B9",
    "FontStyleKoreanLegacy": "\uE1BA",
    "UnderlineLKoreanLegacy": "\uE1BB",
    "ItalicKoreanLegacy": "\uE1BC",
    "BoldKoreanLegacy": "\uE1BD",
    "FontColorKoreanLegacy": "\uE1BE",
    "ClosePaneLegacyMirrored": "\uE1BF",
    "OpenPaneLegacyMirrored": "\uE1C0",
    "EditLegacyMirrored": "\uE1C2",
    "StreetLegacy": "\uE1C3",
    "MapLegacy": "\uE1C4",
    "ClearSelectionLegacy": "\uE1C5",
    "FontDecreaseLegacy": "\uE1C6",
    "FontIncreaseLegacy": "\uE1C7",
    "FontSizeLegacy": "\uE1C8",
    "CellPhoneLegacy": "\uE1C9",
    "ReshareLegacy": "\uE1CA",
    "TagLegacy": "\uE1CB",
    "RepeatOneLegacy": "\uE1CC",
    "RepeatAllLegacy": "\uE1CD",
    "OutlineStarLegacy": "\uE1CE",
    "SolidStarLegacy": "\uE1CF",
    "CalculatorLegacy": "\uE1D0",
    "DirectionsLegacy": "\uE1D1",
    "LocationLegacy": "\uE1D2",
    "LibraryLegacy": "\uE1D3",
    "PhoneBookLegacy": "\uE1D4",
    "MemoLegacy": "\uE1D5",
    "MicrophoneLegacy": "\uE1D6",
    "PostUpdateLegacy": "\uE1D7",
    "BackToWindowLegacy": "\uE1D8",
    "FullScreenLegacy": "\uE1D9",
    "NewFolderLegacy": "\uE1DA",
    "CalendarReplyLegacy": "\uE1DB",
    "CalendarLegacyMirrored": "\uE1DC",
    "UnsyncFolderLegacy": "\uE1DD",
    "ReportHackedLegacy": "\uE1DE",
    "SyncFolderLegacy": "\uE1DF",
    "BlockContactLegacy": "\uE1E0",
    "SwitchAppsLegacy": "\uE1E1",
    "AddFriendLegacy": "\uE1E2",
    "TouchPointerLegacy": "\uE1E3",
    "GoToStartLegacy": "\uE1E4",
    "ZeroBarsLegacy": "\uE1E5",
    "OneBarLegacy": "\uE1E6",
    "TwoBarsLegacy": "\uE1E7",
    "ThreeBarsLegacy": "\uE1E8",
    "FourBarsLegacy": "\uE1E9",
    "ItalicRussianLegacy": "\uE1EA",
    "AllAppsLegacyMirrored": "\uE1EC",
    "OpenWithLegacyMirrored": "\uE1ED",
    "BookmarksLegacyMirrored": "\uE1EE",
    "MultiSelectLegacyMirrored": "\uE1EF",
    "ShowResultsLegacyMirrored": "\uE1F1",
    "MailReplyAllLegacyMirrored": "\uE1F2",
    "HelpLegacyMirrored": "\uE1F3",
    "ClearSelectionLegacyMirrored": "\uE1F4",
    "RecordLegacy": "\uE1F5",
    "LockLegacy": "\uE1F6",
    "UnlockLegacy": "\uE1F7",
    "DownLegacy": "\uE1FD",
    "CommentInlineLegacy": "\uE206",
    "FavoriteInlineLegacy": "\uE208",
    "LikeInlineLegacy": "\uE209",
    "VideoInlineLegacy": "\uE20A",
    "MailMessageLegacy": "\uE20B",
    "PC1Legacy": "\uE211",
    "DevicesLegacy": "\uE212",
    "RatingStarLegacy": "\uE224",
    "ChevronDownSmLegacy": "\uE228",
    "ReplyLegacy": "\uE248",
    "Favorite2Legacy": "\uE249",
    "Unfavorite2Legacy": "\uE24A",
    "MobileContactLegacy": "\uE25A",
    "BlockedLegacy": "\uE25B",
    "TypingIndicatorLegacy": "\uE25C",
    "PresenceChickletVideoLegacy": "\uE25D",
    "PresenceChickletLegacy": "\uE25E",
    "ChevronRightSmLegacy": "\uE26B",
    "ChevronLeftSmLegacy": "\uE26C",
    "SaveAsLegacy": "\uE28F",
    "DecreaseIndentLegacy": "\uE290",
    "IncreaseIndentLegacy": "\uE291",
    "BulletedListLegacy": "\uE292",
    "ScanLegacy": "\uE294",
    "PreviewLegacy": "\uE295",
    "DecreaseIndentLegacyMirrored": "\uE297",
    "IncreaseIndentLegacyMirrored": "\uE298",
    "BulletedListLegacyMirrored": "\uE299",
    "PlayOnLegacy": "\uE29B",
    "ResolutionLegacy": "\uE2AC",
    "LengthLegacy": "\uE2AD",
    "LayoutLegacy": "\uE2AE",
    "Contact3Legacy": "\uE2AF",
    "TypeLegacy": "\uE2B0",
    "ColorLegacy": "\uE2B1",
    "SizeLegacy": "\uE2B2",
    "ReturnToWindowLegacy": "\uE2B3",
    "OpenInNewWindowLegacy": "\uE2B4",
    "PrintLegacy": "\uE2F6",
    "Printer3DLegacy": "\uE2F7",
    "GlobalNavButton": "\uE700",
    "Wifi": "\uE701",
    "Bluetooth": "\uE702",
    "Connect": "\uE703",
    "InternetSharing": "\uE704",
    "VPN": "\uE705",
    "Brightness": "\uE706",
    "MapPin": "\uE707",
    "QuietHours": "\uE708",
    "Airplane": "\uE709",
    "Tablet": "\uE70A",
    "QuickNote": "\uE70B",
    "RememberedDevice": "\uE70C",
    "ChevronDown": "\uE70D",
    "ChevronUp": "\uE70E",
    "Edit": "\uE70F",
    "Add": "\uE710",
    "Cancel": "\uE711",
    "More": "\uE712",
    "Settings": "\uE713",
    "Video": "\uE714",
    "Mail": "\uE715",
    "People": "\uE716",
    "Phone": "\uE717",
    "Pin": "\uE718",
    "Shop": "\uE719",
    "Stop": "\uE71A",
    "Link": "\uE71B",
    "Filter": "\uE71C",
    "AllApps": "\uE71D",
    "Zoom": "\uE71E",
    "ZoomOut": "\uE71F",
    "Microphone": "\uE720",
    "Search": "\uE721",
    "Camera": "\uE722",
    "Attach": "\uE723",
    "Send": "\uE724",
    "SendFill": "\uE725",
    "WalkSolid": "\uE726",
    "InPrivate": "\uE727",
    "FavoriteList": "\uE728",
    "PageSolid": "\uE729",
    "Forward": "\uE72A",
    "Back": "\uE72B",
    "Refresh": "\uE72C",
    "Share": "\uE72D",
    "Lock": "\uE72E",
    "ReportHacked": "\uE730",
    "FavoriteStar": "\uE734",
    "FavoriteStarFill": "\uE735",
    "Remove": "\uE738",
    "Checkbox": "\uE739",
    "CheckboxComposite": "\uE73A",
    "CheckboxFill": "\uE73B",
    "CheckboxIndeterminate": "\uE73C",
    "CheckboxCompositeReversed": "\uE73D",
    "CheckMark": "\uE73E",
    "BackToWindow": "\uE73F",
    "FullScreen": "\uE740",
    "ResizeTouchLarger": "\uE741",
    "ResizeTouchSmaller": "\uE742",
    "ResizeMouseSmall": "\uE743",
    "ResizeMouseMedium": "\uE744",
    "ResizeMouseWide": "\uE745",
    "ResizeMouseTall": "\uE746",
    "ResizeMouseLarge": "\uE747",
    "SwitchUser": "\uE748",
    "Print": "\uE749",
    "Up": "\uE74A",
    "Down": "\uE74B",
    "OEM": "\uE74C",
    "Delete": "\uE74D",
    "Save": "\uE74E",
    "Mute": "\uE74F",
    "BackSpaceQWERTY": "\uE750",
    "ReturnKey": "\uE751",
    "UpArrowShiftKey": "\uE752",
    "Cloud": "\uE753",
    "Flashlight": "\uE754",
    "RotationLock": "\uE755",
    "CommandPrompt": "\uE756",
    "SIPMove": "\uE759",
    "SIPUndock": "\uE75A",
    "SIPRedock": "\uE75B",
    "EraseTool": "\uE75C",
    "UnderscoreSpace": "\uE75D",
    "GripperTool": "\uE75E",
    "Dialpad": "\uE75F",
    "PageLeft": "\uE760",
    "PageRight": "\uE761",
    "MultiSelect": "\uE762",
    "KeyboardLeftHanded": "\uE763",
    "KeyboardRightHanded": "\uE764",
    "KeyboardClassic": "\uE765",
    "KeyboardSplit": "\uE766",
    "Volume": "\uE767",
    "Play": "\uE768",
    "Pause": "\uE769",
    "ChevronLeft": "\uE76B",
    "ChevronRight": "\uE76C",
    "InkingTool": "\uE76D",
    "Emoji2": "\uE76E",
    "GripperBarHorizontal": "\uE76F",
    "System": "\uE770",
    "Personalize": "\uE771",
    "Devices": "\uE772",
    "SearchAndApps": "\uE773",
    "Globe": "\uE774",
    "TimeLanguage": "\uE775",
    "EaseOfAccess": "\uE776",
    "UpdateRestore": "\uE777",
    "HangUp": "\uE778",
    "ContactInfo": "\uE779",
    "Unpin": "\uE77A",
    "Contact": "\uE77B",
    "Memo": "\uE77C",
    "Paste": "\uE77F",
    "PhoneBook": "\uE780",
    "LEDLight": "\uE781",
    "Error": "\uE783",
    "GripperBarVertical": "\uE784",
    "Unlock": "\uE785",
    "Slideshow": "\uE786",
    "Calendar": "\uE787",
    "GripperResize": "\uE788",
    "Megaphone": "\uE789",
    "Trim": "\uE78A",
    "NewWindow": "\uE78B",
    "SaveLocal": "\uE78C",
    "Color": "\uE790",
    "DataSense": "\uE791",
    "SaveAs": "\uE792",
    "Light": "\uE793",
    "AspectRatio": "\uE799",
    "DataSenseBar": "\uE7A5",
    "Redo": "\uE7A6",
    "Undo": "\uE7A7",
    "Crop": "\uE7A8",
    "OpenWith": "\uE7AC",
    "Rotate": "\uE7AD",
    "SetlockScreen": "\uE7B5",
    "MapPin2": "\uE7B7",
    "Package": "\uE7B8",
    "Warning": "\uE7BA",
    "ReadingList": "\uE7BC",
    "Education": "\uE7BE",
    "ShoppingCart": "\uE7BF",
    "Train": "\uE7C0",
    "Flag": "\uE7C1",
    "Page": "\uE7C3",
    "Multitask": "\uE7C4",
    "BrowsePhotos": "\uE7C5",
    "HalfStarLeft": "\uE7C6",
    "HalfStarRight": "\uE7C7",
    "Record": "\uE7C8",
    "TouchPointer": "\uE7C9",
    "LangJPN": "\uE7DE",
    "Ferry": "\uE7E3",
    "Highlight": "\uE7E6",
    "ActionCenterNotification": "\uE7E7",
    "PowerButton": "\uE7E8",
    "ResizeTouchNarrower": "\uE7EA",
    "ResizeTouchShorter": "\uE7EB",
    "DrivingMode": "\uE7EC",
    "RingerSilent": "\uE7ED",
    "OtherUser": "\uE7EE",
    "Admin": "\uE7EF",
    "CC": "\uE7F0",
    "SDCard": "\uE7F1",
    "CallForwarding": "\uE7F2",
    "SettingsDisplaySound": "\uE7F3",
    "TVMonitor": "\uE7F4",
    "Speakers": "\uE7F5",
    "Headphone": "\uE7F6",
    "DeviceLaptopPic": "\uE7F7",
    "DeviceLaptopNoPic": "\uE7F8",
    "DeviceMonitorRightPic": "\uE7F9",
    "DeviceMonitorLeftPic": "\uE7FA",
    "DeviceMonitorNoPic": "\uE7FB",
    "Game": "\uE7FC",
    "HorizontalTabKey": "\uE7FD",
    "StreetsideSplitMinimize": "\uE802",
    "StreetsideSplitExpand": "\uE803",
    "Car": "\uE804",
    "Walk": "\uE805",
    "Bus": "\uE806",
    "TiltUp": "\uE809",
    "TiltDown": "\uE80A",
    "RotateMapRight": "\uE80C",
    "RotateMapLeft": "\uE80D",
    "Home": "\uE80F",
    "ParkingLocation": "\uE811",
    "MapCompassTop": "\uE812",
    "MapCompassBottom": "\uE813",
    "IncidentTriangle": "\uE814",
    "Touch": "\uE815",
    "MapDirections": "\uE816",
    "StartPoint": "\uE819",
    "StopPoint": "\uE81A",
    "EndPoint": "\uE81B",
    "History": "\uE81C",
    "Location": "\uE81D",
    "MapLayers": "\uE81E",
    "Accident": "\uE81F",
    "Work": "\uE821",
    "Construction": "\uE822",
    "Recent": "\uE823",
    "Bank": "\uE825",
    "DownloadMap": "\uE826",
    "InkingToolFill2": "\uE829",
    "HighlightFill2": "\uE82A",
    "EraseToolFill": "\uE82B",
    "EraseToolFill2": "\uE82C",
    "Dictionary": "\uE82D",
    "DictionaryAdd": "\uE82E",
    "ToolTip": "\uE82F",
    "ChromeBack": "\uE830",
    "ProvisioningPackage": "\uE835",
    "AddRemoteDevice": "\uE836",
    "Ethernet": "\uE839",
    " ShareBroadband": "\uE83A",
    "DirectAccess": "\uE83B",
    " DialUp": "\uE83C",
    "DefenderApp": "\uE83D",
    "BatteryCharging9": "\uE83E",
    "Battery10": "\uE83F",
    "Pinned": "\uE840",
    "PinFill": "\uE841",
    "PinnedFill": "\uE842",
    "PeriodKey": "\uE843",
    "PuncKey": "\uE844",
    "RevToggleKey": "\uE845",
    "RightArrowKeyTime1": "\uE846",
    "RightArrowKeyTime2": "\uE847",
    "LeftQuote": "\uE848",
    "RightQuote": "\uE849",
    "DownShiftKey": "\uE84A",
    "UpShiftKey": "\uE84B",
    "PuncKey0": "\uE84C",
    "PuncKeyLeftBottom": "\uE84D",
    "RightArrowKeyTime3": "\uE84E",
    "RightArrowKeyTime4": "\uE84F",
    "Battery0": "\uE850",
    "Battery1": "\uE851",
    "Battery2": "\uE852",
    "Battery3": "\uE853",
    "Battery4": "\uE854",
    "Battery5": "\uE855",
    "Battery6": "\uE856",
    "Battery7": "\uE857",
    "Battery8": "\uE858",
    "Battery9": "\uE859",
    "BatteryCharging0": "\uE85A",
    "BatteryCharging1": "\uE85B",
    "BatteryCharging2": "\uE85C",
    "BatteryCharging3": "\uE85D",
    "BatteryCharging4": "\uE85E",
    "BatteryCharging5": "\uE85F",
    "BatteryCharging6": "\uE860",
    "BatteryCharging7": "\uE861",
    "BatteryCharging8": "\uE862",
    "BatterySaver0": "\uE863",
    "BatterySaver1": "\uE864",
    "BatterySaver2": "\uE865",
    "BatterySaver3": "\uE866",
    "BatterySaver4": "\uE867",
    "BatterySaver5": "\uE868",
    "BatterySaver6": "\uE869",
    "BatterySaver7": "\uE86A",
    "BatterySaver8": "\uE86B",
    "SignalBars1": "\uE86C",
    "SignalBars2": "\uE86D",
    "SignalBars3": "\uE86E",
    "SignalBars4": "\uE86F",
    "SignalBars5": "\uE870",
    "SignalNotConnected": "\uE871",
    "Wifi1": "\uE872",
    "Wifi2": "\uE873",
    "Wifi3": "\uE874",
    "SIMLock": "\uE875",
    "SIMMissing": "\uE876",
    "Vibrate": "\uE877",
    "RoamingInternational": "\uE878",
    "RoamingDomestic": "\uE879",
    "CallForwardInternational": "\uE87A",
    "CallForwardRoaming": "\uE87B",
    "JpnRomanji": "\uE87C",
    "JpnRomanjiLock": "\uE87D",
    "JpnRomanjiShift": "\uE87E",
    "JpnRomanjiShiftLock": "\uE87F",
    "StatusDataTransfer": "\uE880",
    "StatusDataTransferVPN": "\uE881",
    "StatusDualSIM2": "\uE882",
    "StatusDualSIM2VPN": "\uE883",
    "StatusDualSIM1": "\uE884",
    "StatusDualSIM1VPN": "\uE885",
    "StatusSGLTE": "\uE886",
    "StatusSGLTECell": "\uE887",
    "StatusSGLTEDataVPN": "\uE888",
    "StatusVPN": "\uE889",
    "WifiHotspot": "\uE88A",
    "LanguageKor": "\uE88B",
    "LanguageCht": "\uE88C",
    "LanguageChs": "\uE88D",
    "USB": "\uE88E",
    "InkingToolFill": "\uE88F",
    "View": "\uE890",
    "HighlightFill": "\uE891",
    "Previous": "\uE892",
    "Next": "\uE893",
    "Clear": "\uE894",
    "Sync": "\uE895",
    "Download": "\uE896",
    "Help": "\uE897",
    "Upload": "\uE898",
    "Emoji": "\uE899",
    "TwoPage": "\uE89A",
    "LeaveChat": "\uE89B",
    "MailForward": "\uE89C",
    "RotateCamera": "\uE89E",
    "ClosePane": "\uE89F",
    "OpenPane": "\uE8A0",
    "PreviewLink": "\uE8A1",
    "AttachCamera": "\uE8A2",
    "ZoomIn": "\uE8A3",
    "Bookmarks": "\uE8A4",
    "Document": "\uE8A5",
    "ProtectedDocument": "\uE8A6",
    "OpenInNewWindow": "\uE8A7",
    "MailFill": "\uE8A8",
    "ViewAll": "\uE8A9",
    "VideoChat": "\uE8AA",
    "Switch": "\uE8AB",
    "Rename": "\uE8AC",
    "Go": "\uE8AD",
    "SurfaceHub": "\uE8AE",
    "Remote": "\uE8AF",
    "Click": "\uE8B0",
    "Shuffle": "\uE8B1",
    "Movies": "\uE8B2",
    "SelectAll": "\uE8B3",
    "Orientation": "\uE8B4",
    "Import": "\uE8B5",
    "ImportAll": "\uE8B6",
    "Folder": "\uE8B7",
    "Webcam": "\uE8B8",
    "Picture": "\uE8B9",
    "Caption": "\uE8BA",
    "ChromeClose": "\uE8BB",
    "ShowResults": "\uE8BC",
    "Message": "\uE8BD",
    "Leaf": "\uE8BE",
    "CalendarDay": "\uE8BF",
    "CalendarWeek": "\uE8C0",
    "Characters": "\uE8C1",
    "MailReplyAll": "\uE8C2",
    "Read": "\uE8C3",
    "ShowBcc": "\uE8C4",
    "HideBcc": "\uE8C5",
    "Cut": "\uE8C6",
    "Copy": "\uE8C8",
    "Important": "\uE8C9",
    "MailReply": "\uE8CA",
    "Sort": "\uE8CB",
    "MobileTablet": "\uE8CC",
    "DisconnectDrive": "\uE8CD",
    "MapDrive": "\uE8CE",
    "ContactPresence": "\uE8CF",
    "Priority": "\uE8D0",
    "GotoToday": "\uE8D1",
    "Font": "\uE8D2",
    "FontColor": "\uE8D3",
    "Contact2": "\uE8D4",
    "FolderFill": "\uE8D5",
    "Audio": "\uE8D6",
    "Permissions": "\uE8D7",
    "DisableUpdates": "\uE8D8",
    "Unfavorite": "\uE8D9",
    "OpenLocal": "\uE8DA",
    "Italic": "\uE8DB",
    "Underline": "\uE8DC",
    "Bold": "\uE8DD",
    "MoveToFolder": "\uE8DE",
    "LikeDislike": "\uE8DF",
    "Dislike": "\uE8E0",
    "Like": "\uE8E1",
    "AlignRight": "\uE8E2",
    "AlignCenter": "\uE8E3",
    "AlignLeft": "\uE8E4",
    "OpenFile": "\uE8E5",
    "ClearSelection": "\uE8E6",
    "FontDecrease": "\uE8E7",
    "FontIncrease": "\uE8E8",
    "FontSize": "\uE8E9",
    "CellPhone": "\uE8EA",
    "Reshare": "\uE8EB",
    "Tag": "\uE8EC",
    "RepeatOne": "\uE8ED",
    "RepeatAll": "\uE8EE",
    "Calculator": "\uE8EF",
    "Directions": "\uE8F0",
    "Library": "\uE8F1",
    "ChatBubbles": "\uE8F2",
    "PostUpdate": "\uE8F3",
    "NewFolder": "\uE8F4",
    "CalendarReply": "\uE8F5",
    "UnsyncFolder": "\uE8F6",
    "SyncFolder": "\uE8F7",
    "BlockContact": "\uE8F8",
    "SwitchApps": "\uE8F9",
    "AddFriend": "\uE8FA",
    "Accept": "\uE8FB",
    "GoToStart": "\uE8FC",
    "BulletedList": "\uE8FD",
    "Scan": "\uE8FE",
    "Preview": "\uE8FF",
    "ZeroBars": "\uE904",
    "OneBar": "\uE905",
    "TwoBars": "\uE906",
    "ThreeBars": "\uE907",
    "FourBars": "\uE908",
    "World": "\uE909",
    "Comment": "\uE90A",
    "MusicInfo": "\uE90B",
    "DockLeft": "\uE90C",
    "DockRight": "\uE90D",
    "DockBottom": "\uE90E",
    "Repair": "\uE90F",
    "Accounts": "\uE910",
    "DullSound": "\uE911",
    "Manage": "\uE912",
    "Street": "\uE913",
    "Printer3D": "\uE914",
    "RadioBullet": "\uE915",
    "Stopwatch": "\uE916",
    "Photo": "\uE91B",
    "ActionCenter": "\uE91C",
    "FullCircleMask": "\uE91F",
    "ChromeMinimize": "\uE921",
    "ChromeMaximize": "\uE922",
    "ChromeRestore": "\uE923",
    "Annotation": "\uE924",
    "BackSpaceQWERTYSm": "\uE925",
    "BackSpaceQWERTYMd": "\uE926",
    "Swipe": "\uE927",
    "Fingerprint": "\uE928",
    "Handwriting": "\uE929",
    "ChromeBackToWindow": "\uE92C",
    "ChromeFullScreen": "\uE92D",
    "KeyboardStandard": "\uE92E",
    "KeyboardDismiss": "\uE92F",
    "Completed": "\uE930",
    "ChromeAnnotate": "\uE931",
    "Label": "\uE932",
    "IBeam": "\uE933",
    "IBeamOutline": "\uE934",
    "FlickDown": "\uE935",
    "FlickUp": "\uE936",
    "FlickLeft": "\uE937",
    "FlickRight": "\uE938",
    "FeedbackApp": "\uE939",
    "MusicAlbum": "\uE93C",
    "Streaming": "\uE93E",
    "Code": "\uE943",
    "ReturnToWindow": "\uE944",
    "LightningBolt": "\uE945",
    "Info": "\uE946",
    "CalculatorMultiply": "\uE947",
    "CalculatorAddition": "\uE948",
    "CalculatorSubtract": "\uE949",
    "CalculatorDivide": "\uE94A",
    "CalculatorSquareroot": "\uE94B",
    "CalculatorPercentage": "\uE94C",
    "CalculatorNegate": "\uE94D",
    "CalculatorEqualTo": "\uE94E",
    "CalculatorBackspace": "\uE94F",
    "Component": "\uE950",
    "DMC": "\uE951",
    "Dock": "\uE952",
    "MultimediaDMS": "\uE953",
    "MultimediaDVR": "\uE954",
    "MultimediaPMP": "\uE955",
    "PrintfaxPrinterFile": "\uE956",
    "Sensor": "\uE957",
    "StorageOptical": "\uE958",
    "Communications": "\uE95A",
    "Headset": "\uE95B",
    "Projector": "\uE95D",
    "Health": "\uE95E",
    "Webcam2": "\uE960",
    "Input": "\uE961",
    "Mouse": "\uE962",
    "Smartcard": "\uE963",
    "SmartcardVirtual": "\uE964",
    "MediaStorageTower": "\uE965",
    "ReturnKeySm": "\uE966",
    "GameConsole": "\uE967",
    "Network": "\uE968",
    "StorageNetworkWireless": "\uE969",
    "StorageTape": "\uE96A",
    "ChevronUpSmall": "\uE96D",
    "ChevronDownSmall": "\uE96E",
    "ChevronLeftSmall": "\uE96F",
    "ChevronRightSmall": "\uE970",
    "ChevronUpMed": "\uE971",
    "ChevronDownMed": "\uE972",
    "ChevronLeftMed": "\uE973",
    "ChevronRightMed": "\uE974",
    "Devices2": "\uE975",
    "ExpandTile": "\uE976",
    "PC1": "\uE977",
    "PresenceChicklet": "\uE978",
    "PresenceChickletVideo": "\uE979",
    "Reply": "\uE97A",
    "SetTile": "\uE97B",
    "Type": "\uE97C",
    "Korean": "\uE97D",
    "HalfAlpha": "\uE97E",
    "FullAlpha": "\uE97F",
    "Key12On": "\uE980",
    "ChineseChangjie": "\uE981",
    "QWERTYOn": "\uE982",
    "QWERTYOff": "\uE983",
    "ChineseQuick": "\uE984",
    "Japanese": "\uE985",
    "FullHiragana": "\uE986",
    "FullKatakana": "\uE987",
    "HalfKatakana": "\uE988",
    "ChineseBoPoMoFo": "\uE989",
    "ChinesePinyin": "\uE98A",
    "ConstructionCone": "\uE98F",
    "XboxOneConsole": "\uE990",
    "Volume0": "\uE992",
    "Volume1": "\uE993",
    "Volume2": "\uE994",
    "Volume3": "\uE995",
    "BatteryUnknown": "\uE996",
    "WifiAttentionOverlay": "\uE998",
    "Robot": "\uE99A",
    "TapAndSend": "\uE9A1",
    "PasswordKeyShow": "\uE9A8",
    "PasswordKeyHide": "\uE9A9",
    "BidiLtr": "\uE9AA",
    "BidiRtl": "\uE9AB",
    "ForwardSm": "\uE9AC",
    "CommaKey": "\uE9AD",
    "DashKey": "\uE9AE",
    "DullSoundKey": "\uE9AF",
    "HalfDullSound": "\uE9B0",
    "RightDoubleQuote": "\uE9B1",
    "LeftDoubleQuote": "\uE9B2",
    "PuncKeyRightBottom": "\uE9B3",
    "PuncKey1": "\uE9B4",
    "PuncKey2": "\uE9B5",
    "PuncKey3": "\uE9B6",
    "PuncKey4": "\uE9B7",
    "PuncKey5": "\uE9B8",
    "PuncKey6": "\uE9B9",
    "PuncKey9": "\uE9BA",
    "PuncKey7": "\uE9BB",
    "PuncKey8": "\uE9BC",
    "Frigid": "\uE9CA",
    "Diagnostic": "\uE9D9",
    "Process": "\uE9F3",
    "DisconnectDisplay": "\uEA14",
    "Info2": "\uEA1F",
    "ActionCenterAsterisk": "\uEA21",
    "Beta": "\uEA24",
    "SaveCopy": "\uEA35",
    "List": "\uEA37",
    "Asterisk": "\uEA38",
    "ErrorBadge": "\uEA39",
    "CircleRing": "\uEA3A",
    "CircleFill": "\uEA3B",
    "AllAppsMirrored": "\uEA40",
    "BookmarksMirrored": "\uEA41",
    "BulletedListMirrored": "\uEA42",
    "CallForwardInternationalMirrored": "\uEA43",
    "CallForwardRoamingMirrored": "\uEA44",
    "ChromeBackMirrored": "\uEA47",
    "ClearSelectionMirrored": "\uEA48",
    "ClosePaneMirrored": "\uEA49",
    "ContactInfoMirrored": "\uEA4A",
    "DockRightMirrored": "\uEA4B",
    "DockLeftMirrored": "\uEA4C",
    "ExpandTileMirrored": "\uEA4E",
    "GoMirrored": "\uEA4F",
    "GripperResizeMirrored": "\uEA50",
    "HelpMirrored": "\uEA51",
    "ImportMirrored": "\uEA52",
    "ImportAllMirrored": "\uEA53",
    "LeaveChatMirrored": "\uEA54",
    "ListMirrored": "\uEA55",
    "MailForwardMirrored": "\uEA56",
    "MailReplyMirrored": "\uEA57",
    "MailReplyAllMirrored": "\uEA58",
    "OpenPaneMirrored": "\uEA5B",
    "OpenWithMirrored": "\uEA5C",
    "ParkingLocationMirrored": "\uEA5E",
    "ResizeMouseMediumMirrored": "\uEA5F",
    "ResizeMouseSmallMirrored": "\uEA60",
    "ResizeMouseTallMirrored": "\uEA61",
    "ResizeTouchNarrowerMirrored": "\uEA62",
    "SendMirrored": "\uEA63",
    "SendFillMirrored": "\uEA64",
    "ShowResultsMirrored": "\uEA65",
    "Media": "\uEA69",
    "SyncError": "\uEA6A",
    "Devices3": "\uEA6C",
    "Lightbulb": "\uEA80",
    "StatusCircle": "\uEA81",
    "StatusTriangle": "\uEA82",
    "StatusError": "\uEA83",
    "StatusWarning": "\uEA84",
    "Puzzle": "\uEA86",
    "CalendarSolid": "\uEA89",
    "HomeSolid": "\uEA8A",
    "ParkingLocationSolid": "\uEA8B",
    "ContactSolid": "\uEA8C",
    "ConstructionSolid": "\uEA8D",
    "AccidentSolid": "\uEA8E",
    "Ringer": "\uEA8F",
    "ThoughtBubble": "\uEA91",
    "HeartBroken": "\uEA92",
    "BatteryCharging10": "\uEA93",
    "BatterySaver9": "\uEA94",
    "BatterySaver10": "\uEA95",
    "CallForwardingMirrored": "\uEA97",
    "MultiSelectMirrored": "\uEA98",
    "Broom": "\uEA99",
    "Trackers": "\uEADF",
    "PieSingle": "\uEB05",
    "StockDown": "\uEB0F",
    "StockUp": "\uEB11",
    "Drop": "\uEB42",
    "BusSolid": "\uEB47",
    "FerrySolid": "\uEB48",
    "StartPointSolid": "\uEB49",
    "StopPointSolid": "\uEB4A",
    "EndPointSolid": "\uEB4B",
    "AirplaneSolid": "\uEB4C",
    "TrainSolid": "\uEB4D",
    "WorkSolid": "\uEB4E",
    "ReminderFill": "\uEB4F",
    "Reminder": "\uEB50",
    "Heart": "\uEB51",
    "HeartFill": "\uEB52",
    "EthernetError": "\uEB55",
    "EthernetWarning": "\uEB56",
    "StatusConnecting1": "\uEB57",
    "StatusConnecting2": "\uEB58",
    "StatusUnsecure": "\uEB59",
    "WifiError0": "\uEB5A",
    "WifiError1": "\uEB5B",
    "WifiError2": "\uEB5C",
    "WifiError3": "\uEB5D",
    "WifiError4": "\uEB5E",
    "WifiWarning0": "\uEB5F",
    "WifiWarning1": "\uEB60",
    "WifiWarning2": "\uEB61",
    "WifiWarning3": "\uEB62",
    "WifiWarning4": "\uEB63",
    "Devices4": "\uEB66",
    "NUIIris": "\uEB67",
    "NUIFace": "\uEB68",
    "EditMirrored": "\uEB7E",
    "NUIFPStartSlideHand": "\uEB82",
    "NUIFPStartSlideAction": "\uEB83",
    "NUIFPContinueSlideHand": "\uEB84",
    "NUIFPContinueSlideAction": "\uEB85",
    "NUIFPRollRightHand": "\uEB86",
    "NUIFPRollRightHandAction": "\uEB87",
    "NUIFPRollLeftHand": "\uEB88",
    "NUIFPRollLeftAction": "\uEB89",
    "NUIFPPressHand": "\uEB8A",
    "NUIFPPressAction": "\uEB8B",
    "NUIFPPressRepeatHand": "\uEB8C",
    "NUIFPPressRepeatAction": "\uEB8D",
    "StatusErrorFull": "\uEB90",
    "MultitaskExpanded": "\uEB91",
    "Certificate": "\uEB95",
    "BackSpaceQWERTYLg": "\uEB96",
    "ReturnKeyLg": "\uEB97",
    "FastForward": "\uEB9D",
    "Rewind": "\uEB9E",
    "Photo2": "\uEB9F",
    " MobBattery0": "\uEBA0",
    " MobBattery1": "\uEBA1",
    " MobBattery2": "\uEBA2",
    " MobBattery3": "\uEBA3",
    " MobBattery4": "\uEBA4",
    " MobBattery5": "\uEBA5",
    " MobBattery6": "\uEBA6",
    " MobBattery7": "\uEBA7",
    " MobBattery8": "\uEBA8",
    " MobBattery9": "\uEBA9",
    "MobBattery10": "\uEBAA",
    " MobBatteryCharging0": "\uEBAB",
    " MobBatteryCharging1": "\uEBAC",
    " MobBatteryCharging2": "\uEBAD",
    " MobBatteryCharging3": "\uEBAE",
    " MobBatteryCharging4": "\uEBAF",
    " MobBatteryCharging5": "\uEBB0",
    " MobBatteryCharging6": "\uEBB1",
    " MobBatteryCharging7": "\uEBB2",
    " MobBatteryCharging8": "\uEBB3",
    " MobBatteryCharging9": "\uEBB4",
    " MobBatteryCharging10": "\uEBB5",
    " MobBatterySaver0": "\uEBB6",
    " MobBatterySaver1": "\uEBB7",
    " MobBatterySaver2": "\uEBB8",
    " MobBatterySaver3": "\uEBB9",
    " MobBatterySaver4": "\uEBBA",
    " MobBatterySaver5": "\uEBBB",
    " MobBatterySaver6": "\uEBBC",
    " MobBatterySaver7": "\uEBBD",
    " MobBatterySaver8": "\uEBBE",
    " MobBatterySaver9": "\uEBBF",
    " MobBatterySaver10": "\uEBC0",
    "DictionaryCloud": "\uEBC3",
    "ResetDrive": "\uEBC4",
    "VolumeBars": "\uEBC5",
    "Project": "\uEBC6",
    "AdjustHologram": "\uEBD2",
    "WifiCallBars": "\uEBD4",
    "WifiCall0": "\uEBD5",
    "WifiCall1": "\uEBD6",
    "WifiCall2": "\uEBD7",
    "WifiCall3": "\uEBD8",
    "WifiCall4": "\uEBD9",
    "DeviceDiscovery": "\uEBDE",
    "WindDirection": "\uEBE6",
    "RightArrowKeyTime0": "\uEBE7",
    "TabletMode": "\uEBFC",
    "StatusCircleLeft": "\uEBFD",
    "StatusTriangleLeft": "\uEBFE",
    "StatusErrorLeft": "\uEBFF",
    "StatusWarningLeft": "\uEC00",
    "MobBatteryUnknown": "\uEC02",
    "NetworkTower": "\uEC05",
    "CityNext": "\uEC06",
    "CityNext2": "\uEC07",
    "Courthouse": "\uEC08",
    "Groceries": "\uEC09",
    "Sustainable": "\uEC0A",
    "BuildingEnergy": "\uEC0B",
    "ToggleFilled": "\uEC11",
    "ToggleBorder": "\uEC12",
    "SliderThumb": "\uEC13",
    "ToggleThumb": "\uEC14",
    "MiracastLogoSmall": "\uEC15",
    "MiracastLogoLarge": "\uEC16",
    "PLAP": "\uEC19",
    "Badge": "\uEC1B",
    "SignalRoaming": "\uEC1E",
    "MobileLocked": "\uEC20",
    "InsiderHubApp": "\uEC24",
    "PersonalFolder": "\uEC25",
    "HomeGroup": "\uEC26",
    "MyNetwork": "\uEC27",
    "KeyboardFull": "\uEC31",
    "MobSignal1": "\uEC37",
    "MobSignal2": "\uEC38",
    "MobSignal3": "\uEC39",
    "MobSignal4": "\uEC3A",
    "MobSignal5": "\uEC3B",
    "MobWifi1": "\uEC3C",
    "MobWifi2": "\uEC3D",
    "MobWifi3": "\uEC3E",
    "MobWifi4": "\uEC3F",
    "MobAirplane": "\uEC40",
    "MobBluetooth": "\uEC41",
    "MobActionCenter": "\uEC42",
    "MobLocation": "\uEC43",
    "MobWifiHotspot": "\uEC44",
    "LanguageJpn": "\uEC45",
    "MobQuietHours": "\uEC46",
    "MobDrivingMode": "\uEC47",
    "SpeedOff": "\uEC48",
    "SpeedMedium": "\uEC49",
    "SpeedHigh": "\uEC4A",
    "ThisPC": "\uEC4E",
    "MusicNote": "\uEC4F",
    "FileExplorer": "\uEC50",
    "FileExplorerApp": "\uEC51",
    "LeftArrowKeyTime0": "\uEC52",
    "MicOff": "\uEC54",
    "MicSleep": "\uEC55",
    "MicError": "\uEC56",
    "PlaybackRate1x": "\uEC57",
    "PlaybackRateOther": "\uEC58",
    "CashDrawer": "\uEC59",
    "BarcodeScanner": "\uEC5A",
    "ReceiptPrinter": "\uEC5B",
    "MagStripeReader": "\uEC5C",
    "CompletedSolid": "\uEC61",
    "CompanionApp": "\uEC64",
    "SwipeRevealArt": "\uEC6D",
    "MicOn": "\uEC71",
    "MicClipping": "\uEC72",
    "TabletSelected": "\uEC74",
    "MobileSelected": "\uEC75",
    "LaptopSelected": "\uEC76",
    "TVMonitorSelected": "\uEC77",
    "DeveloperTools": "\uEC7A",
    "MobCallForwarding": "\uEC7E",
    "MobCallForwardingMirrored": "\uEC7F",
    "BodyCam": "\uEC80",
    "PoliceCar": "\uEC81",
    "Draw": "\uEC87",
    "DrawSolid": "\uEC88",
    "LowerBrightness": "\uEC8A",
    "ScrollUpDown": "\uEC8F",
    "DateTime": "\uEC92",
    "Tiles": "\uECA5",
    "PartyLeader": "\uECA7",
    "AppIconDefault": "\uECAA",
    "AddSurfaceHub": "\uECC4",
    "DevUpdate": "\uECC5",
    "Unit": "\uECC6",
    "AddTo": "\uECC8",
    "RemoveFrom": "\uECC9",
    "RadioBtnOff": "\uECCA",
    "RadioBtnOn": "\uECCB",
    "RadioBullet2": "\uECCC",
    "ExploreContent": "\uECCD",
    "ScrollMode": "\uECE7",
    "ZoomMode": "\uECE8",
    "PanMode": "\uECE9",
    "WiredUSB ": "\uECF0",
    "WirelessUSB": "\uECF1",
    "USBSafeConnect": "\uECF3",
    "ActionCenterNotificationMirrored": "\uED0C",
    "ActionCenterMirrored": "\uED0D",
    "ResetDevice": "\uED10",
    "Feedback": "\uED15",
    "Subtitles": "\uED1E",
    "SubtitlesAudio": "\uED1F",
    "CalendarMirrored": "\uED28",
    "eSIM": "\uED2A",
    "eSIMNoProfile": "\uED2B",
    "eSIMLocked": "\uED2C",
    "eSIMBusy": "\uED2D",
    "SignalError": "\uED2E",
    "StreamingEnterprise": "\uED2F",
    "Headphone0": "\uED30",
    "Headphone1": "\uED31",
    "Headphone2": "\uED32",
    "Headphone3": "\uED33",
    "KeyboardBrightness": "\uED39",
    "KeyboardLowerBrightness": "\uED3A",
    "SkipBack10": "\uED3C",
    "SkipForward30": "\uED3D",
    "TreeFolderFolder": "\uED41",
    "TreeFolderFolderFill": "\uED42",
    "TreeFolderFolderOpen": "\uED43",
    "TreeFolderFolderOpenFill": "\uED44",
    "MultimediaDMP": "\uED47",
    "KeyboardOneHanded": "\uED4C",
    "Narrator": "\uED4D",
    "EmojiTabPeople": "\uED53",
    "EmojiTabSmilesAnimals": "\uED54",
    "EmojiTabCelebrationObjects": "\uED55",
    "EmojiTabFoodPlants": "\uED56",
    "EmojiTabTransitPlaces": "\uED57",
    "EmojiTabSymbols": "\uED58",
    "EmojiTabTextSmiles": "\uED59",
    "EmojiTabFavorites": "\uED5A",
    "EmojiSwatch": "\uED5B",
    "ConnectApp": "\uED5C",
    "CompanionDeviceFramework": "\uED5D",
    "Ruler": "\uED5E",
    "FingerInking": "\uED5F",
    "StrokeErase": "\uED60",
    "PointErase": "\uED61",
    "ClearAllInk": "\uED62",
    "Pencil": "\uED63",
    "Marker": "\uED64",
    "InkingCaret": "\uED65",
    "InkingColorOutline": "\uED66",
    "InkingColorFill": "\uED67",
    "HardDrive": "\uEDA2",
    "NetworkAdapter": "\uEDA3",
    "Touchscreen": "\uEDA4",
    "NetworkPrinter": "\uEDA5",
    "CloudPrinter": "\uEDA6",
    "KeyboardShortcut": "\uEDA7",
    "BrushSize": "\uEDA8",
    "NarratorForward": "\uEDA9",
    "NarratorForwardMirrored": "\uEDAA",
    "SyncBadge12": "\uEDAB",
    "RingerBadge12": "\uEDAC",
    "AsteriskBadge12": "\uEDAD",
    "ErrorBadge12": "\uEDAE",
    "CircleRingBadge12": "\uEDAF",
    "CircleFillBadge12": "\uEDB0",
    "ImportantBadge12": "\uEDB1",
    "MailBadge12": "\uEDB3",
    "PauseBadge12": "\uEDB4",
    "PlayBadge12": "\uEDB5",
    "PenWorkspace": "\uEDC6",
    "Export": "\uEDE1",
    "ExportMirrored": "\uEDE2",
    "CaligraphyPen": "\uEDFB",
    "ReplyMirrored": "\uEE35",
    "LockscreenDesktop": "\uEE3F",
    "Multitask16": "\uEE40",
    "Play36": "\uEE4A",
    "PenPalette": "\uEE56",
    "GuestUser": "\uEE57",
    "SettingsBattery": "\uEE63",
    "TaskbarPhone": "\uEE64",
    "LockScreenGlance": "\uEE65",
    "ImageExport": "\uEE71",
    "WifiEthernet": "\uEE77",
    "ActionCenterQuiet": "\uEE79",
    "ActionCenterQuietNotification": "\uEE7A",
    "TrackersMirrored": "\uEE92",
    "DateTimeMirrored": "\uEE93",
    "Wheel": "\uEE94",
    "PenWorkspaceMirrored": "\uEF15",
    "PenPaletteMirrored": "\uEF16",
    "StrokeEraseMirrored": "\uEF17",
    "PointEraseMirrored": "\uEF18",
    "ClearAllInkMirrored": "\uEF19",
    "BackgroundToggle": "\uEF1F",
    "Marquee": "\uEF20"
};
//# sourceMappingURL=icons.js.map